var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPrintSolid = function SvgPrintSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10c.957 0 1.75.793 1.75 1.75v2.625c0 .492-.41.875-.875.875h-.875v2.625c0 .492-.41.875-.875.875h-8.75a.864.864 0 0 1-.875-.875V15.25h-.875A.864.864 0 0 1 5 14.375V11.75c0-.957.766-1.75 1.75-1.75h10.5Zm-1.75 7v-2.625h-7V17h7Zm1.313-4.156a.648.648 0 0 0 .656-.656c0-.356-.301-.657-.657-.657-.382 0-.656.301-.656.656 0 .383.274.657.657.657ZM8.5 6.5v2.625H6.75v-3.5c0-.465.383-.875.875-.875h7.492a.89.89 0 0 1 .63.273l1.23 1.23a.89.89 0 0 1 .273.63v2.242H15.5V7.238l-.738-.738H8.5Z"
  })));
};

export default SvgPrintSolid;